import { render, staticRenderFns } from "./ButtonBookAllFile.vue?vue&type=template&id=64b083fe&scoped=true&"
import script from "./ButtonBookAllFile.vue?vue&type=script&lang=js&"
export * from "./ButtonBookAllFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b083fe",
  null
  
)

export default component.exports